import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { authService } from "../../services/authService";
// import { loyaltyService } from "../../services/loyaltyService"; // HIDDEN - Loyalty program disabled

const Header = () => {
  const location = useLocation();
  const history = useHistory();
  const currentUser = authService.getCurrentUser();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  // const [loyaltyPoints, setLoyaltyPoints] = useState(0); // HIDDEN - Loyalty program disabled
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // HIDDEN - Loyalty points fetching disabled
  /*
  // Fetch loyalty points on mount
  useEffect(() => {
    const fetchLoyaltyPoints = async () => {
      try {
        const response = await loyaltyService.getLoyaltyPoints();
        if (response.success) {
          setLoyaltyPoints(response.data.current_balance || 0);
        }
      } catch (error) {
        console.error('Error fetching loyalty points:', error);
      }
    };

    if (currentUser) {
      fetchLoyaltyPoints();
    }
  }, [currentUser]);
  */

  const logout = () => {
    authService.logout();
  };

  // Fermer le dropdown et le menu mobile quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setShowMobileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header row headerSection">
      <div className="col-6 col-md-6">
        <Link to="/commande">
          <img
            src="/Marion livraison pano.png"
            alt="Marion"
            className="header-logo"
            style={{ maxWidth: '100px', width: '100%', height: 'auto' }}
          />
        </Link>
      </div>
      <div className="col-6 col-md-6 d-flex justify-content-end align-items-center gap-3">
        {/* Bouton hamburger - visible uniquement sur mobile */}
        <button
          className="btn d-md-none hamburger-btn"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          aria-label="Menu"
        >
          <i className={`fas ${showMobileMenu ? 'fa-times' : 'fa-bars'}`} style={{ fontSize: '24px' }}></i>
        </button>

        {/* Menu desktop - caché sur mobile */}
        <div className="d-none d-md-flex align-items-center gap-3">
        <Link
          to="/commande"
          className={`btn btn-custom-menu ${location.pathname === "/commande" ? "active" : ""}`}
        >
          Nouvelle livraison
        </Link>

        <Link
          to="/historique"
          className={`btn btn-custom-menu ${location.pathname === "/historique" ? "active" : ""}`}
        >
          Historique des livraisons
        </Link>

        {currentUser && (
          <div className="position-relative" ref={dropdownRef}>
            <button
              className="btn btn-link p-0 text-decoration-none"
              onClick={() => setShowDropdown(!showDropdown)}
              style={{ border: 'none', background: 'transparent' }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                  style={{
                    width: '40px',
                    height: '40px',
                    fontSize: '18px',
                    fontWeight: 'bold'
                  }}
                >
                  <i className="fas fa-user"></i>
                </div>
                <div className="d-none d-md-flex flex-column align-items-start">
                  <span className="text-dark">
                    {currentUser.prenom} {currentUser.nom}
                  </span>
                  {/* LOYALTY POINTS - HIDDEN
                  {loyaltyPoints > 0 && (
                    <small className="text-warning fw-bold">
                      <i className="fas fa-star"></i> {loyaltyPoints} pts
                    </small>
                  )}
                  */}
                </div>
                <i className={`fas fa-chevron-${showDropdown ? 'up' : 'down'} text-dark`}></i>
              </div>
            </button>

            {showDropdown && (
              <div
                className="position-absolute end-0 mt-2 bg-white rounded shadow-lg"
                style={{
                  minWidth: '200px',
                  zIndex: 1000,
                  border: '1px solid #dee2e6'
                }}
              >
                <div className="py-2">
                  <button
                    className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
                    onClick={() => {
                      history.push('/account');
                      setShowDropdown(false);
                    }}
                    style={{
                      cursor: 'pointer',
                      border: 'none',
                      background: 'transparent',
                      width: '100%',
                      textAlign: 'left'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <i className="fas fa-user-circle"></i>
                    Mon compte
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
                    onClick={() => {
                      history.push('/preferences');
                      setShowDropdown(false);
                    }}
                    style={{
                      cursor: 'pointer',
                      border: 'none',
                      background: 'transparent',
                      width: '100%',
                      textAlign: 'left'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <i className="fas fa-cog"></i>
                    Mes préférences
                  </button>
                  {/* LOYALTY & REFERRAL - HIDDEN
                  <button
                    className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
                    onClick={() => {
                      history.push('/loyalty');
                      setShowDropdown(false);
                    }}
                    style={{
                      cursor: 'pointer',
                      border: 'none',
                      background: 'transparent',
                      width: '100%',
                      textAlign: 'left'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <i className="fas fa-star text-warning"></i>
                    Fidélité & Parrainage
                    {loyaltyPoints > 0 && (
                      <span className="badge bg-warning text-dark ms-auto">{loyaltyPoints}</span>
                    )}
                  </button>
                  */}
                  <hr className="my-1" />
                  <button
                    className="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-danger"
                    onClick={() => {
                      setShowDropdown(false);
                      logout();
                    }}
                    style={{
                      cursor: 'pointer',
                      border: 'none',
                      background: 'transparent',
                      width: '100%',
                      textAlign: 'left'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <i className="fas fa-sign-out-alt"></i>
                    Se déconnecter
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        </div>

        {/* Menu mobile - visible uniquement sur mobile */}
        {showMobileMenu && (
          <div
            ref={mobileMenuRef}
            className="mobile-menu d-md-none"
          >
            <div className="mobile-menu-content">
              <Link
                to="/commande"
                className={`mobile-menu-item ${location.pathname === "/commande" ? "active" : ""}`}
                onClick={() => setShowMobileMenu(false)}
              >
                <i className="fas fa-truck"></i>
                <span>Nouvelle livraison</span>
              </Link>

              <Link
                to="/historique"
                className={`mobile-menu-item ${location.pathname === "/historique" ? "active" : ""}`}
                onClick={() => setShowMobileMenu(false)}
              >
                <i className="fas fa-history"></i>
                <span>Historique des livraisons</span>
              </Link>

              <button
                className="mobile-menu-item"
                onClick={() => {
                  history.push('/account');
                  setShowMobileMenu(false);
                }}
              >
                <i className="fas fa-user-circle"></i>
                <span>Mon compte</span>
              </button>

              <button
                className="mobile-menu-item"
                onClick={() => {
                  history.push('/preferences');
                  setShowMobileMenu(false);
                }}
              >
                <i className="fas fa-cog"></i>
                <span>Mes préférences</span>
              </button>

              {/* LOYALTY & REFERRAL - HIDDEN
              <button
                className="mobile-menu-item"
                onClick={() => {
                  history.push('/loyalty');
                  setShowMobileMenu(false);
                }}
              >
                <i className="fas fa-star text-warning"></i>
                <span>Fidélité & Parrainage</span>
                {loyaltyPoints > 0 && (
                  <span className="badge bg-warning text-dark ms-auto">{loyaltyPoints}</span>
                )}
              </button>
              */}

              <hr className="mobile-menu-divider" />

              <button
                className="mobile-menu-item text-danger"
                onClick={() => {
                  setShowMobileMenu(false);
                  logout();
                }}
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Se déconnecter</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
